<main>
  <myp-s1-status-header></myp-s1-status-header>
  <!-- Page title - visually hidden but accessible -->
  <div class="sr-only">
    <fui-heading [text]="(user.active_subscription ? env.studioOnePlusBrandName : 'PreSonus') + ': Home'" [level]="1" fontSize="f11"></fui-heading>
  </div>
  <!-- END | section: your profile -->
  <!-- START | section: your profile -->
  <div class="secondary-content-bg m-b-20">
    <div class="fullwidth-layout-container">
      @if (needsMoreData && userService.dataWeNeed && userService.dataWeNeed.length) {
        <section class="home-section w-full" aria-label="your profile">
          <div class="p-t-30 p-b-50 data-we-need">
            <div class="section-header is-grid">
              <fui-heading [text]="'sphere.your_profile' | translate" [level]="2" fontSize="f8"></fui-heading>
              <a class="section-header-link" [routerLink]="['../account/general']">{{ "profile.edit_profile" | translate }}</a>
            </div>
            <div class="d-flex">
              <div>
                <div class="data-we-need-profile-photo" [ngStyle]="{ 'background-image': user.photoURL ? 'url(' + user.photoURL + ')' : 'url(./assets/images/default_avatar.jpg)' }">
                  <round-progress
                    [current]="profileProgress.percentage"
                    max="100"
                    [color]="appService.activeTheme == 'dark' ? '#d52b1e' : '#121212'"
                    [background]="appService.activeTheme == 'dark' ? '#333' : '#eaeaea'"
                    [radius]="55"
                    [stroke]="5"
                    [semicircle]="false"
                    [rounded]="true"
                    [clockwise]="true"
                    [responsive]="false"
                    [duration]="250"
                    [animation]="'easeInOutQuart'"
                    [animationDelay]="0"
                  ></round-progress>
                  <button class="btn btn-sm" [class.btn-primary]="appService.activeTheme == 'dark'" [class.btn-secondary]="appService.activeTheme == 'light'">
                    {{ profileProgress.percentage }}% {{ "home.complete" | translate }}
                  </button>
                </div>
              </div>
              <div class="m-l-50">
                <fui-heading [text]="user.firstName + ' ' + user.lastName" [level]="2" fontSize="f5"></fui-heading>
                <div class="t-14 m-b-10 m-t-10">Member since {{ user.createdTime | date: "YYYY" }}</div>
                <div class="t-12 m-b-20">{{ "account.completing_your_profile" | translate }}</div>
                <div class="need-pills">
                  <ul class="more-info-list">
                    @for (field of userService.dataWeNeed; track field) {
                      <li [class.done]="field.key == 'skills' ? user.skills.length > 0 : user[field.key]">
                        <a [routerLink]="['../account/general']">
                          <fa-icon [icon]="field.key == 'skills' ? (user.skills.length > 0 ? 'check' : 'times') : user[field.key] ? 'check' : 'times'"></fa-icon>
                          <span class="sr-only">{{ field.key == "skills" ? (user.skills.length > 0 ? "Complete " : "Missing ") : user[field.key] ? "Complete " : "Missing " }}</span>
                          {{ field.translation_key | translate }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
            <button class="btn btn-primary btn-sm mobile-data-we-need-button" [routerLink]="['../account/general']">Complete Profile</button>
          </div>
        </section>
      }
    </div>
  </div>
  <div>
    <div basepage="primary" class="fullwidth-layout-container">
      <div class="row">
        <div class="col-12">
          <myp-new-product-added></myp-new-product-added>

          <!-- START | section: your products -->
          <section class="home-section w-full m-b-50" aria-label="products">
            @if (recentProducts && recentProducts.length) {
              <div class="section-header is-grid m-b-20">
                <fui-heading [text]="'newdash.newest_products' | translate" [level]="2" fontSize="f8"></fui-heading>
                @if (recentProducts && recentProducts.length) {
                  <a class="section-header-link" [routerLink]="['../products']">{{ "sphere.view_all" | translate }}</a>
                }
              </div>
            }
            @if (productsLoading) {
              <div class="grid-container even-rows pad-10">
                <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
              </div>
            }

            @if (!productsLoading) {
              @if (recentProducts && !recentProducts.length) {
                <div class="d-flex align-items-center m-y-20">
                  <div class="fui-header-hero">
                    <div>
                      <div class="d-flex justify-content-center m-b-20">
                        <myp-svg id="fender-logo" class="svg-white" width="100" height="50" style="margin-right: 20px" />
                        <myp-svg id="presonus-logo" class="svg-white" width="130" height="50" />
                      </div>
                      <div class="d-flex justify-content-center m-b-30 flex-wrap">
                        <myp-svg id="jackson-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="charvel-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="evh-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="gretsch-logo" class="svg-white m-x-10" width="90" height="45" />
                      </div>
                      <fui-heading [text]="'my_gear.register_your_gear' | translate" color="white" textAlign="center" [level]="2" fontSize="f9"></fui-heading>
                      <span class="text-center">{{ "my_gear.register_your_gear_description" | translate }}</span>
                      <div>
                        <button class="btn btn-secondary white m-t-30" (click)="registerProduct()">{{ "my_gear.register_your_gear_button" | translate }}</button>
                        <button class="btn btn-blank m-t-30 c-white" (click)="appService.goToFenderShop()">
                          {{ "my_gear.register_your_gear_button_fender" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <ul class="grid-container even-rows pad-4">
                @if (recentProducts?.length) {
                  <li class="mr-0">
                    <myp-product-tile (registerProductClicked)="registerProduct()" [registerProductTile]="true" class="h-full register-product-tile"></myp-product-tile>
                  </li>
                }
                @if (productService.elligleToRedeemStudioOneSeven) {
                  <li class="mr-0">
                    <myp-product-tile (redeems17Clicked)="redeemS17()" [redeemS17Tile]="true" class="h-full"></myp-product-tile>
                  </li>
                }
                @if (recentProducts && recentProducts.length) {
                  @for (prod of recentProducts; track prod) {
                    <li class="mr-0">
                      <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod" class="h-full pt-0"></myp-product-tile>
                    </li>
                  }
                }
              </ul>
            }
          </section>
          <!-- END | section: your products -->

          @if (eventsService.inProgressEvents.length) {
            <div class="home-section w-full m-b-50">
              <fui-heading [text]="'home.happening_now' | translate" [level]="2" fontSize="f8"></fui-heading>
              <div class="d-flex">
                @if (
                  this.contentService.videosByPlatformId[eventsService.inProgressEvents[0].livestream_id] &&
                  this.contentService.videosByPlatformId[eventsService.inProgressEvents[0].livestream_id].image
                ) {
                  <div style="width: 100%; max-width: 200px; margin-right: 15px">
                    <img [src]="this.contentService.videosByPlatformId[eventsService.inProgressEvents[0].livestream_id].image" class="image-border w-full" />
                  </div>
                }
                <div>
                  <fui-heading [text]="eventsService.inProgressEvents[0].title_events" [level]="3" fontSize="f7"></fui-heading>
                  <div>
                    {{ "home.started_at" | translate }} {{ eventsService.inProgressEvents[0].start_utc | date: "h:mma" : false }}{{ "home.ends_at" | translate }}
                    {{ eventsService.inProgressEvents[0].end_utc | date: "h:mma" : false }}
                  </div>
                  @if (eventsService.inProgressEvents[0].livestream_id) {
                    <div class="m-t-20">
                      <a class="btn btn-primary" (click)="openLivestream(eventsService.inProgressEvents[0].livestream_id)">{{ "home.launch_livestream" | translate }}</a>
                    </div>
                  }
                  @if (!eventsService.inProgressEvents[0].livestream_id) {
                    <div class="m-t-20">
                      <a class="btn btn-primary" [routerLink]="['../events/detail/' + eventsService.inProgressEvents[0].id_events]">{{ "home.view_event" | translate }}</a>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          <!-- START | section: latest videos -->
          <section class="home-section w-full m-b-50" aria-label="latest videos">
            <div class="section-header is-grid m-b-20">
              <fui-heading [text]="'sphere.latest_videos' | translate" [level]="2" fontSize="f8"></fui-heading>
              <a class="section-header-link" [routerLink]="['../learn/videos/all']">{{ "sphere.view_all" | translate }}</a>
            </div>

            @if (videosLoading) {
              <div class="grid-container even-rows pad-10">
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
              </div>
            }
            <ul class="list-inline grid-container wider even-rows pad-10">
              @for (video of videos; track video) {
                <li class="list-inline-item">
                  <myp-video-grid-item [usePandaComponent]="true" [video]="video"></myp-video-grid-item>
                </li>
              }
            </ul>
          </section>
          <!-- END | section: latest videos -->

          <!-- START | section: redeemable bundled products -->
          @if (productService.redeemableBundledProducts?.length) {
            <div class="home-section w-full m-b-50">
              <div class="section-header is-grid">
                <fui-heading [text]="'home.products_you_can_redeem' | translate" [level]="2" fontSize="f8"></fui-heading>
              </div>
              <div class="m-b-20">{{ "home.redeem_products_message" | translate }}</div>
              <ul class="grid-container even-rows pad-4">
                @for (prod of productService.redeemableBundledProducts; track prod) {
                  <li class="mr-0">
                    <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod" class="h-full pt-0"></myp-product-tile>
                  </li>
                }
              </ul>
            </div>
          }
          <!-- END | section: redeemable bundled products -->

          <!-- START | section: upgrades -->
          @if (!user.active_subscription && user.subscription?.status != "expired" && !user.subscription?.cancel_date) {
            <section class="home-section w-full m-b-50" aria-label="upgrades">
              <div class="section-header is-grid m-b-20">
                <fui-heading [text]="'home.upgrades_special_offers' | translate" [level]="2" fontSize="f8"></fui-heading>
              </div>
              <div class="align-items-center m-b-50 offer-container">
                <img
                  [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual"
                  class="m-r-20 offer-image"
                  style="max-width: 300px; display: inline-block"
                  width="100%"
                  alt=""
                />
                <div class="offer-text">
                  <fui-heading [text]="'home.subscribe_fender_studio_pro_plus' | translate" level="2" fontSize="f6"></fui-heading>
                  {{ "home.fender_studio_pro_description" | translate }}
                  <br />
                  <br />
                  <button type="button" class="btn btn-primary" (click)="upgrade()">{{ "onboarding.join_now" | translate }}</button>
                </div>
              </div>
              <div class="align-items-center m-b-50 m-t-30 offer-container">
                <img
                  src="https://www.fender.com/cdn-cgi/image/format=auto/https://images.ctfassets.net/mdpgzc1lmx9t/6dm00mq0ASKUzDJDdqaxEV/042e46e027dc46b6270eeebc6e325536/Fender_Studio_Edit_Tracks-v3.webp"
                  class="m-r-20 offer-image"
                  style="max-width: 300px; display: inline-block"
                  width="100%"
                  alt=""
                />
                <div class="offer-text">
                  <fui-heading [text]="'home.fender_studio_mobile_app_free' | translate" level="2" fontSize="f6"></fui-heading>
                  {{ "home.fender_studio_pro_description" | translate }}
                  <br />
                  <br />
                  <img
                    src="https://images.ctfassets.net/r1mvpfown1y6/I6wP6wbRgu6nl2WbKiTUr/0ebfd271a4fba0070940955c767f23a0/Download_on_the_App_Store_Badge.svg"
                    style="width: 150px; margin-right: 10px; display: inline-block"
                    alt=""
                  />
                  <img
                    src="https://images.ctfassets.net/r1mvpfown1y6/cGKmfaCPBarxVgSTlprue/40bcb9596a2801c09c62d19d1a915c04/google-play-badge__2_.png"
                    style="width: 150px; display: inline-block"
                    alt=""
                  />
                </div>
              </div>
            </section>
          }
          <!-- END | section: upgrades -->
        </div>
      </div>
    </div>
  </div>

  <div class="fullwidth-layout-container">
    <div class="row">
      <div class="col-12">
        @if (
          (!user.active_subscription && user.subscription && user.subscription.status == "expired" && !user.subscription.cancel_date) ||
          (!user.active_subscription && user.subscription && user.subscription.status == "expired" && user.subscription.cancel_date)
        ) {
          <div class="home-section w-full m-b-50">
            @if (!user.active_subscription && user.subscription && user.subscription.status == "expired" && !user.subscription.cancel_date) {
              <div class="m-b-20">
                <fui-heading [text]="'sphere.account.reactivate_subscription' | translate" [level]="3" fontSize="f7" extraClasses="section-header is-grid m-b-20"></fui-heading>
                <div class="align-items-center m-b-50 offer-container">
                  <img src="./assets/images/presonus-sphere-bundle.png" class="m-r-20 offer-image" style="max-width: 300px; display: inline-block" width="100%" alt="" />
                  <div class="offer-text">
                    <span>{{ "newdash.reactivate_membership_msg" | translate }}</span>
                    <br />
                    <br />
                    <a class="btn btn-primary" (click)="upgrade()">{{ "sphere.account.reactivate_subscription" | translate }}</a>
                  </div>
                </div>
              </div>
            }
            @if (!user.active_subscription && user.subscription && user.subscription.status == "expired" && user.subscription.cancel_date) {
              <div class="m-b-20">
                <fui-heading [text]="'sphere.account.reactivate_subscription' | translate" [level]="3" fontSize="f7" extraClasses="section-header is-grid m-b-20"></fui-heading>
                <span>
                  {{ "newdash.miss_you_msg" | translate }}
                </span>
                <br />
                <br />
                <a class="btn btn-primary" [routerLink]="['../account/plan']">{{ "sphere.account.reactivate_subscription" | translate }}</a>
              </div>
            }
          </div>
        }

        <div class="home-section m-b-20 w-full">
          <myp-collaboration-invite-notice></myp-collaboration-invite-notice>
        </div>
      </div>
    </div>
  </div>
</main>

<footer>
  <div class="secondary-content-bg">
    <div class="fullwidth-layout-container">
      <div class="p-t-50">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-3 text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/fender-studio.png" alt="Fender Studio App Icon" />
              <br />
              <span class="fui-heading-font t-16">Fender Studio</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.fender_studio_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/fender-studio" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col-12 col-md-3 text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/play-app-icon.png" alt="Fender Play App Icon" />
              <br />
              <span class="fui-heading-font t-16">Fender Play</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.play_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/play" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col-12 col-md-3 text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tune-app-icon.png" alt="Fender Tune App Icon" />
              <br />
              <span class="fui-heading-font t-16">Fender Tune</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tune_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/online-guitar-tuner/" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col-12 col-md-3 text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tone-app-icon.png" alt="Fender Tone App Icon" />
              <br />
              <span class="fui-heading-font t-16">Fender Tone</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tone_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/tone-app-amp-control" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="m-t-100 p-b-50">
          <fui-footer></fui-footer>
        </div>
      </div>
    </div>
  </div>
</footer>

<ngx-spinner size="large" color="#fff" bdColor="rgba(51,51,51,0.0)" type="line-scale-pulse-out"></ngx-spinner>
